import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  container: {
    width: { md: '240px' },
    flexShrink: 0,
    backgroundColor: 'var(--grey-100)',
    borderRight: '1px solid var(--blue-300)'
  } satisfies SxProps<Theme>,
  header: {
    background: 'var(--dark-blue-gradient)',
    px: '16px',
    py: '12px'
  } satisfies SxProps<Theme>,
  headerTitle: {
    color: 'var(--white)'
  } satisfies SxProps<Theme>,
  hint: {
    backgroundColor: 'var(--blue-50)',
    px: '16px',
    py: '12px'
  } satisfies SxProps<Theme>,
  item: (selected: boolean) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    px: '16px',
    py: '12px',
    cursor: 'pointer',
    borderRight: selected ? '4px solid var(--blue-500)' : '4px solid transparent',
    backgroundColor: selected ? 'var(--white)' : 'transparent',
    color: selected ? 'var(--grey-900)' : 'var(--grey-700)',
    fontWeight: selected ? 700 : 400
  } satisfies SxProps<Theme>)
}
